module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2018_05.7e00d1a3.jpg";